// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2fPR_","box":"WorkspacesBox_box__2xV7O","node":"WorkspacesBox_node__u0kf9"};